<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>

  <div class="top-bar">
    <span class="page-header">
      {{ 'users:usergroups_UserGroup' | i18next }}
    </span>
    <div class="right">
      <app-basic-button *ngIf="model?.canAddUsergroup" type="primary" size="medium" (click)="openAddGroupDialog()"
        [disabled]="!model?.canEditUsers" class="add-button">
        <i class="fal fa-plus"></i>
        <span>{{ 'users:usergroups_addUsergroup_title' | i18next }}</span>
      </app-basic-button>
      <app-filter-input [(model)]="filterText" [placeholder]="'users:usergroups_filterPlaceholder' | i18next"
        [width]="'350px'"></app-filter-input>
    </div>
  </div>

  <div class="content">
    <!-- Loading -->
    <div class="usergroups-loading" *ngIf="isLoading">
      <span class="loading"></span>
    </div>

    <!-- User Groups List -->
    <div class="usergroups-list" *ngIf="!isLoading">
      <div class="accordion-section" *ngFor="let group of filteredGroups" [attr.data-filter]="group.name">

        <!-- Accordion Header -->
        <div class="accordion-header" (click)="toggleGroup(group.id)">
          <h3>
            <i class="fas fa-chevron-right dropdown-button" [class.rotate-down]="expandedGroups.has(group.id)"></i>
            <span class="usergroup-name">{{ getGroupName(group.id) }}</span>
          </h3>
        </div>

        <!-- Accordion Body -->
        <div class="accordion-body" *ngIf="expandedGroups.has(group.id)">
          <!-- User Group Information -->
          <div class="usergroup-info-section">
            <div class="usergroup-info-row">
              <!-- User Group Name -->
              <app-basic-textbox [label]="'users:usergroups_UserGroupName' | i18next " [model]="getGroupName(group.id)"
                (modelChange)="onNameChange(group.id, $event)" [disabled]="!model?.canEditUsers"
                size="small"></app-basic-textbox>
              <!-- Link to Users -->
              <!-- <app-basic-button type="secondary" size="small" [routerLink]="['/users/users-filter/get', group.id]">
                <i class="fal fa-user"></i>
                <span>{{ 'users:users' | i18next }}</span>
                <i class="fas fa-external-link"></i>
              </app-basic-button> -->
              <app-basic-button type="secondary" size="small" (click)="goToUsers(group.id)">
                <i class="fal fa-user"></i>
                <span>{{ 'users:users' | i18next }}</span>
                <i class="fal fa-external-link"></i>
              </app-basic-button>
              <!-- Billing Checkbox (Admin only) -->
              <app-basic-checkbox *ngIf="model?.isAdmin" [label]="'users:usergroups_Billing' | i18next"
                [model]="getGroupBilling(group.id)" (modelChange)="onBillingChange(group.id, $event)"
                [disabled]="!model?.canEditUsers">
              </app-basic-checkbox>

              <div class="right" *ngIf="model?.canEditUsers">
                <app-basic-button type="decline" size="small" (click)="deleteGroup(group.id)">
                  {{ 'Delete' | i18next }}
                </app-basic-button>
                <app-basic-button type="secondary" size="small" (click)="undoChanges(group.id)"
                  [disabled]="!hasChanges(group.id)">
                  {{ 'users:usergroups_undoUsergroupSettings' | i18next }}
                </app-basic-button>
                <app-basic-button type="primary" size="small" (click)="saveChanges(group.id)"
                  [disabled]="!hasChanges(group.id) || hasProfileWithoutSkills(group.id) || hasProfileWithEmptyName(group.id)">
                  {{ 'users:usergroups_saveUsergroupSettings' | i18next }}
                </app-basic-button>
              </div>
            </div>
          </div>

          <!-- Profiles Section -->
          <div class="profiles-section">
            <!-- Loading Profiles -->
            <div class="profiles-loading" *ngIf="loadingGroups.has(group.id)">
              <span class="loading"></span>
            </div>

            <!-- Profiles Table -->
            <table class="profiles-table" *ngIf="!loadingGroups.has(group.id) && groupProfiles[group.id]">
              <thead>
                <tr>
                  <th class="center col-number">#</th>
                  <th class="left col-name">{{ 'users:profileNameHeader' | i18next }}</th>
                  <th class="left col-skills"><span>{{ 'users:skillsHeader' | i18next }} </span>
                    <div class="right"> {{ 'users:newuser_skillsHeader' | i18next }}</div>
                  </th>
                  <th class="center col-use" [matTooltip]="'users:tooltip_useProfile'| i18next"
                    matTooltipClass="tooltip-font-14">{{ 'users:newuser_useProfileHeader' | i18next }}</th>
                  <th class="center col-actions"></th>
                </tr>
              </thead>
              <tbody [cdkDropList]="groupProfiles[group.id]"
                (cdkDropListDropped)="isSortable(group.id) && onProfileDrop($event, group.id)">
                <tr *ngFor="let profile of groupProfiles[group.id]" cdkDrag [cdkDragDisabled]="!isSortable(group.id)">
                  <td class="center col-number">
                    <div class="cell-frame">
                      <button type="button" class="drag-handle-button" cdkDragHandle *ngIf="isSortable(group.id)"
                        [style.cursor]="isSortable(group.id) ? 'move' : 'default'"
                        [attr.aria-label]="'Reorder profile'">
                        <img src="assets/Img/grip-dots-vertical.svg" class="icon-grip-dots" alt="Drag Handle" />
                      </button>
                      {{ profile.number }}
                    </div>
                  </td>
                  <td class="left col-name">
                    <div class="cell-frame">
                      <app-basic-textbox [(model)]="profile.name"
                        (modelChange)="onProfileNameChange(group.id, profile, $event)"
                        [disabled]="!model?.canEditUsers || isSortable(group.id)" size="small" width="176px"
                        class="profile-name-textbox">
                      </app-basic-textbox>
                      <div *ngIf="profile.templateProfileId">{{'users:usergroups_baseonprofiletemplate' | i18next}}
                        {{profile.templateProfileName}}</div>
                    </div>
                  </td>
                  <td class="left col-skills">
                    <div class="cell-frame skills-cell">
                      <!-- <div class="skills-tags">
                        <ng-container *ngIf="hasSkills(profile)">
                          <div class="quality-tag" *ngFor="let quality of getAllQualities(profile)">
                            <span class="quality-name">{{ quality.name }}</span>
                            <app-digit-dropdown [(model)]="quality.userLevel" [disabled]="isSortable(group.id)"
                            (modelChange)="onQualityLevelChange(group.id, profile, quality.qualityId,$event)"
                              [textboxWidth]="'24px'">
                            </app-digit-dropdown>
                            <button class="remove-quality-btn"
                              (click)="removeQuality(group.id, profile, quality.qualityId)" type="button"
                              [disabled]="!model?.canEditUsers || isSortable(group.id)" aria-label="Remove Quality">
                              <i class="fal fa-times"></i>
                            </button>
                          </div>
                        </ng-container>
                        <app-basic-button type="primary" isIcon="true" size="small"
                          (click)="openAddSkillsDialog(group.id, profile)" [disabled]="!model?.canEditUsers || isSortable(group.id)"
                          class="add-skills-button">
                          <i class="fal fa-plus"></i>
                        </app-basic-button>
                      </div> -->
                      <app-skill-tag [profile]="profile" [groupId]="group.id" [canEditUsers]="model?.canEditUsers"
                        [isSortable]="isSortable(group.id)"
                        (qualityLevelChange)="onQualityLevelChange(group.id,profile,$event.qualityId,$event.level)"
                        (removeQuality)="removeQuality(group.id,profile,$event)"
                        (addSkills)="openAddSkillsDialog(group.id, profile)">
                      </app-skill-tag>
                    </div>
                  </td>
                  <td class="center col-use">
                    <div class="cell-frame">
                      <app-basic-checkbox [model]="profile.enableForChildren"
                        (modelChange)="onProfileUseChange(group.id, profile, $event)"
                        [disabled]="!model?.canEditUsers || isSortable(group.id)">
                      </app-basic-checkbox>
                    </div>
                  </td>
                   <td class="center col-actions">
                    <div class="cell-frame actions-cell">
                      <app-basic-button type="secondary" isIcon="true" size="small"
                        [disabled]="!model?.canEditUsers || isSortable(group.id)"
                        (click)="CopyProfile(group.id, profile)" class="edit-button">
                        <i class="fal fa-copy"></i>
                      </app-basic-button>
                      <app-basic-button type="decline" isIcon="true" size="small"
                        [disabled]="!model?.canEditUsers || isSortable(group.id)"
                        (click)="deleteProfile(group.id, profile)" class="delete-button">
                        <i class="fal fa-times"></i>
                      </app-basic-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Profile Actions -->
            <div class="profile-actions" *ngIf="!loadingGroups.has(group.id)">
              <app-basic-button type="secondary" size="medium" (click)="addProfile(group.id)">
                <i class="fal fa-plus"></i>
                {{ 'users:shared_addProfile' | i18next }}
              </app-basic-button>

              <!-- <app-basic-button type="secondary" size="medium" (click)="copySelectedProfiles(group.id)"
                [disabled]="!hasSelectedProfiles()">
                {{ 'users:usergroups_pasteProfile' | i18next : { defaultValue: 'Copy selected Profile(s)' } }}
              </app-basic-button> -->

              <app-basic-button type="secondary" size="medium" (click)="addTemplateProfile(group.id)"
                [disabled]="!model?.templateProfiles || model.templateProfiles.length === 0">
                <i class="fal fa-plus"></i>
                {{ 'users:usergroups_addtemplateprofile_button' | i18next }}
              </app-basic-button>

              <app-basic-button type="secondary" size="medium" (click)="editProfilesNumbers(group.id)"
                [disabled]="!model?.templateProfiles || model.templateProfiles.length === 0 || hasChanges(group.id)">
                <i class="far fa-edit"></i>
                {{ 'users:Edit profile numbers' | i18next }}
              </app-basic-button>


              <span class="profile-actions-hint" *ngIf="isSortable(group.id) && hasChanges(group.id)"><i
                  class="fas fa-exclamation-circle"></i> {{'users:Remember to save profile number changes ' | i18next
                }}</span>
              <span class="profile-actions-hint error" *ngIf="hasProfileWithoutSkills(group.id)"><i
                  class="fas fa-exclamation-circle"></i> {{'users:shared_err_needoneskill' | i18next }}</span>
              <span class="profile-actions-hint error" *ngIf="hasProfileWithEmptyName(group.id)"><i
                  class="fas fa-exclamation-circle"></i> {{'users:shared_err_needprofilename' | i18next }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="usergroups-empty" *ngIf="!isLoading && filteredGroups.length === 0">
        <p>{{ 'users:no_usergroups' | i18next : { defaultValue: 'No user groups found' } }}</p>
      </div>
    </div>
  </div>

  <!-- Skills Panel Overlay -->
  <div class="skills-overlay" *ngIf="showSkillsPanel" (click)="closeSkillsPanel()"></div>

  <!-- Skills Panel -->
  <div class="skills-panel" *ngIf="showSkillsPanel" [@slideInFromRight] (click)="$event.stopPropagation()">
    <app-add-skills *ngIf="currentProfileForSkills && currentGroupIdForSkills && model"
      [profile]="currentProfileForSkills" [groupId]="currentGroupIdForSkills"
      [availableSkills]="model.usergroupServiceQualities || []" (close)="closeSkillsPanel()"
      (skillsSaved)="onSkillsSaved($event)">
    </app-add-skills>
  </div>
</div>